if(!Modernizr.objectfit) {
    // console.log('Welcome to ie');
    $('.img-wrap').each(function () {
        var $container = $(this),
            imgUrl = $container.find('img').prop('src');
        if(imgUrl) {
            $container
                .css('backgroundImage', 'url(' + imgUrl + ')')
                .addClass('compat-object-fit');
        }
    });
} else {
    // console.log("You're using a proper browser");
}
